// Resolves a human-readable brand name for a message's brand.
//
// Some RCS ("chat") messages come back with brand.name === "Unknown" even though
// the RCS agent identifier encodes the real brand, e.g.
//   "tommy_john_mktxb6mp_agent@rbm.goog" -> "Tommy John"
//   "polo_factory_stores_3p5dtbwj_agent@rbm.goog" -> "Polo Factory Stores"
// In those cases we derive a display name from the agent identifier so the card
// doesn't render as "Unknown".

const clean = (value) => (value || '').toString().trim();

const titleCase = (words) =>
	words
		.map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
		.join(' ');

const deriveFromRcsAgent = (phoneNumbers) => {
	if (!Array.isArray(phoneNumbers)) return '';

	for (const raw of phoneNumbers) {
		const val = clean(raw).toLowerCase();
		// Only RCS agent identifiers, e.g. "<brand>_<id>_agent@rbm.goog"
		if (!val.includes('agent') && !val.includes('@rbm')) continue;

		const local = val.split('@')[0]; // "<brand>_<id>_agent"
		const parts = local.split('_').filter(Boolean);

		// Drop the trailing "agent" token…
		if (parts[parts.length - 1] === 'agent') parts.pop();
		// …then drop the random agent-id token that precedes it.
		if (parts.length > 1) parts.pop();

		if (parts.length) return titleCase(parts);
	}

	return '';
};

const getBrandDisplayName = (brand) => {
	const name = clean(brand?.name);
	if (name && name.toLowerCase() !== 'unknown') return name;

	const derived = deriveFromRcsAgent(brand?.phoneNumbers);
	return derived || name || 'Unknown';
};

export default getBrandDisplayName;
